module.exports = __webpack_public_path__ + "static/media/global-shoppng-42.6e6aeb89.png";